module.exports = __webpack_public_path__ + "static/media/yiyuan9.4538812c.png";